export default __webpack_public_path__ + "static/media/AMZN_AT_SH.376852c8.svg";